import React, { useState } from 'react';
import { formatPolnota, formatZapas, validatePolnota, validateZapas, validatePositiveZapas } from './utils';
import { toDecimalPoint } from '../../../utils/decimalUtils';
import DecimalInput from '../../fields/DecimalInput';

const YarusySection = ({
  // Категория земель не «покрытые лесной растительностью» — вся таблица необязательна
  tiersOptional = false,
  dataType,
  isFieldsLocked,
  yarusy,
  getCombinedYarusy,
  handbooks,
  openPicker,
  openCompositionModal,
  updateYarus,
  addYarus,
  removeYarus,
  calculateZapasSyroVydel,
  tableScrollRef,
  tableScrollPosition,
  handleSliderChange,
  handleTableScroll
}) => {
  // Ярус, ожидающий подтверждения удаления (null — окно закрыто)
  const [yarusPendingDelete, setYarusPendingDelete] = useState(null);

  const confirmDeleteYarus = () => {
    if (yarusPendingDelete !== null) {
      removeYarus(yarusPendingDelete);
    }
    setYarusPendingDelete(null);
  };

  return (
    <div className="group-section">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <h4>
          Характеристика насаждения по ярусам
          {tiersOptional && (
            <span style={{ marginLeft: '10px', fontSize: '12px', fontWeight: 400, color: '#6c757d' }}>
              необязательна: выбранная категория земель не покрыта лесной растительностью
            </span>
          )}
        </h4>
        <div>
          {!isFieldsLocked && yarusy.length < 3 && (
            <button
              type="button"
              onClick={addYarus}
              style={{
                background: '#6c757d',
                color: 'white',
                border: 'none',
                padding: '5px 10px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '12px'
              }}
            >
              + Добавить
            </button>
          )}
        </div>
      </div>
      <div 
        ref={tableScrollRef}
        onScroll={handleTableScroll}
        style={{ 
          overflowX: 'auto', 
          overflowY: 'visible',
          maxWidth: '100%',
          border: '1px solid #ddd',
          borderRadius: '6px'
        }}>
        <table className="table" style={{ 
          minWidth: '1200px',
          width: 'max-content',
          marginBottom: 0
        }}>
          <thead>
            <tr>
              <th style={{ minWidth: '52px', width: '52px' }}>Ярус {!tiersOptional && <span className="required">*</span>}</th>
              <th style={{ minWidth: '120px', width: '120px' }}>Состав насаждения {!tiersOptional && <span className="required">*</span>}</th>
              <th style={{ minWidth: '84px', width: '84px' }}>Высота яруса</th>
              <th style={{ minWidth: '100px', width: '100px' }}>Класс возраста</th>
              <th style={{ minWidth: '100px', width: '100px' }}>Группа возраста</th>
              <th style={{ minWidth: '72px', width: '72px' }}>Полнота {!tiersOptional && <span className="required">*</span>}</th>
              <th style={{ minWidth: '150px', width: '150px' }}>Запас сырораст., кбм на га {!tiersOptional && <span className="required">*</span>}</th>
              <th style={{ minWidth: '150px', width: '150px' }}>Запас сырораст., кбм на выдел {!tiersOptional && <span className="required">*</span>}</th>
              <th style={{ minWidth: '150px', width: '150px' }}>Запас сухостоя, кбм на выдел {!tiersOptional && <span className="required">*</span>}</th>
              <th style={{ minWidth: '150px', width: '150px' }}>Запас редин, кбм на выдел {!tiersOptional && <span className="required">*</span>}</th>
              <th style={{ minWidth: '150px', width: '150px' }}>Запас един. дер., кбм на выдел {!tiersOptional && <span className="required">*</span>}</th>
              <th style={{ minWidth: '150px', width: '150px' }}>Запас захл. общ., кбм на выдел {!tiersOptional && <span className="required">*</span>}</th>
              <th style={{ minWidth: '150px', width: '150px' }}>Запас захл. ликвид., кбм на выдел {!tiersOptional && <span className="required">*</span>}</th>
              <th style={{ minWidth: '88px', width: '88px' }}>Действия</th>
            </tr>
          </thead>
          <tbody>
            {getCombinedYarusy().map((yarus) => (
              <tr key={yarus.id}>
                {/* Ярус */}
                <td className="coordinate-cell" style={{ minWidth: '52px', width: '52px' }}>
                  <select
                    value={yarus.yarus}
                    onChange={(e) => {
                      if (!isFieldsLocked) {
                        updateYarus(yarus.id, 'yarus', e.target.value);
                      }
                    }}
                    disabled={true} // Поле яруса всегда только для чтения
                    className={`form-control coordinate-field ${!tiersOptional && (!yarus.yarus) ? 'required-field' : ''}`}
                    style={{ 
                      minHeight: '60px',
                      background: '#f8f9fa',
                      cursor: 'not-allowed',
                      color: '#6c757d'
                    }}
                  >
                    <option value="">Выберите ярус</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </td>

                {/* Состав насаждения */}
                <td className="coordinate-cell" style={{ minWidth: '120px', width: '120px' }}>
                  <div 
                    className={`reference-cell ${isFieldsLocked ? 'locked-field' : ''}`}
                    onClick={() => {
                      if (!isFieldsLocked) {
                        openCompositionModal(yarus.id);
                      }
                    }}
                    style={{ 
                      minHeight: 60, 
                      height: 'auto',
                      cursor: isFieldsLocked ? 'not-allowed' : 'pointer',
                      background: isFieldsLocked ? '#f8f9fa' : 'transparent',
                      border: '1px solid #ced4da',
                      borderRadius: '4px',
                      padding: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}
                  >
                    <span style={{ 
                      color: yarus.sostav ? '#000' : '#6c757d',
                      fontSize: '14px',
                      flex: 1
                    }}>
                      {yarus.sostav || 'Нажмите для редактирования'}
                    </span>
                    <span style={{ color: '#6c757d', fontSize: '12px' }}>☰</span>
                  </div>
                </td>

                {/* Высота яруса */}
                <td className="coordinate-cell" style={{ minWidth: '72px', width: '72px' }}>
                  <input
                    type="number"
                    min="1"
                    max="999"
                    step="1"
                    value={yarus.visota}
                    onChange={(e) => {
                      if (!isFieldsLocked) {
                        const value = e.target.value;
                        // Разрешаем только целые числа от 1 до 999
                        if (value === '' || (Number.isInteger(Number(value)) && Number(value) >= 1 && Number(value) <= 999)) {
                          updateYarus(yarus.id, 'visota', value);
                        }
                      }
                    }}
                    readOnly={isFieldsLocked}
                    className={`form-control coordinate-field ${isFieldsLocked ? 'locked-field' : ''}`}
                    style={isFieldsLocked ? { background: '#f8f9fa', cursor: 'not-allowed' } : {}}
                    placeholder="1-999"
                  />
                </td>

                {/* Класс возраста */}
                <td className="coordinate-cell" style={{ minWidth: '100px', width: '100px' }}>
                  <div 
                    className={`reference-cell ${isFieldsLocked ? 'locked-field' : ''}`}
                    onClick={() => {
                      if (!isFieldsLocked) {
                        openPicker('klvozr', 26, yarus.id);
                      }
                    }}
                    style={{ 
                      minHeight: 60, 
                      height: 'auto',
                      cursor: isFieldsLocked ? 'not-allowed' : 'pointer',
                      background: isFieldsLocked ? '#f8f9fa' : 'transparent',
                      position: 'relative'
                    }}
                  >
                    <textarea
                      readOnly
                      value={(() => {
                        if (yarus.klvozr) {
                          // Ищем в справочнике с ID 26 (Класс возраста)
                          const handbook = handbooks.find(h => h.id === 26);
                          if (handbook && handbook.references) {
                            // Пробуем найти по строке и по числу
                            let selectedOption = handbook.references.find(r => r.id.toString() === yarus.klvozr);
                            if (!selectedOption) {
                              selectedOption = handbook.references.find(r => r.id === parseInt(yarus.klvozr));
                            }
                            if (selectedOption) {
                              return selectedOption.name;
                            }
                          }
                        }
                        return '';
                      })()}
                      placeholder="☰"
                      style={{
                        border: 'none',
                        outline: 'none',
                        resize: 'none',
                        width: '100%',
                        height: '100%',
                        background: 'transparent',
                        color: yarus.klvozr ? '#495057' : '#6c757d',
                        fontStyle: yarus.klvozr ? 'normal' : 'italic'
                      }}
                      className="form-control coordinate-field"
                    />
                  </div>
                </td>

                {/* Группа возраста */}
                <td className="coordinate-cell" style={{ minWidth: '100px', width: '100px' }}>
                  <div 
                    className={`reference-cell ${isFieldsLocked ? 'locked-field' : ''}`}
                    onClick={() => {
                      if (!isFieldsLocked) {
                        openPicker('grvozr', 27, yarus.id);
                      }
                    }}
                    style={{ 
                      minHeight: 60, 
                      height: 'auto',
                      cursor: isFieldsLocked ? 'not-allowed' : 'pointer',
                      background: isFieldsLocked ? '#f8f9fa' : 'transparent',
                      position: 'relative'
                    }}
                  >
                    <textarea
                      readOnly
                      value={(() => {
                        if (yarus.grvozr) {
                          // Ищем в справочнике с ID 27 (Группа возраста)
                          const handbook = handbooks.find(h => h.id === 27);
                          if (handbook && handbook.references) {
                            // Пробуем найти по строке и по числу
                            let selectedOption = handbook.references.find(r => r.id.toString() === yarus.grvozr);
                            if (!selectedOption) {
                              selectedOption = handbook.references.find(r => r.id === parseInt(yarus.grvozr));
                            }
                            if (selectedOption) {
                              return selectedOption.name;
                            }
                          }
                        }
                        return '';
                      })()}
                      placeholder="☰"
                      style={{
                        border: 'none',
                        outline: 'none',
                        resize: 'none',
                        width: '100%',
                        height: '100%',
                        background: 'transparent',
                        color: yarus.grvozr ? '#495057' : '#6c757d',
                        fontStyle: yarus.grvozr ? 'normal' : 'italic'
                      }}
                      className="form-control coordinate-field"
                    />
                  </div>
                </td>

                {/* Полнота */}
                <td className="coordinate-cell" style={{ minWidth: '84px', width: '84px' }}>
                  <DecimalInput
                    value={yarus.polnota}
                    onChange={(e) => {
                      if (!isFieldsLocked) {
                        updateYarus(yarus.id, 'polnota', toDecimalPoint(e.target.value));
                      }
                    }}
                    onBlur={(e) => {
                      if (!isFieldsLocked) {
                        const formatted = formatPolnota(e.target.value);
                        const yarusNumber = parseInt(yarus.yarus);
                        
                        // Проверяем валидацию после форматирования
                        if (formatted && !validatePolnota(formatted, yarusNumber)) {
                          const minValue = yarusNumber === 1 ? '0.00' : '0.30';
                          alert(`Ошибка: Полнота для ${yarusNumber} яруса должна быть от ${minValue} до 1.30`);
                          return; // Не сохраняем неверное значение
                        }
                        
                        updateYarus(yarus.id, 'polnota', formatted);
                      }
                    }}
                    readOnly={isFieldsLocked}
                    className={`form-control coordinate-field ${!tiersOptional && (!yarus.polnota || !validatePolnota(yarus.polnota, parseInt(yarus.yarus))) ? 'required-field' : ''} ${isFieldsLocked ? 'locked-field' : ''}`}
                    style={{
                      ...(isFieldsLocked ? { background: '#f8f9fa', cursor: 'not-allowed' } : {}),
                      ...(yarus.polnota && !validatePolnota(yarus.polnota, parseInt(yarus.yarus)) ? { 
                        border: '2px solid #dc3545', 
                        background: '#fff5f5' 
                      } : {})
                    }}
                    placeholder={parseInt(yarus.yarus) === 1 ? "0.00-1.30" : "0.30-1.30"}
                  />
                </td>

                {/* Запас сырораст., кбм на га */}
                <td className="coordinate-cell" style={{ minWidth: '150px', width: '150px' }}>
                  <DecimalInput
                    value={yarus.zapassirga}
                    onChange={(e) => {
                      if (!isFieldsLocked) {
                        updateYarus(yarus.id, 'zapassirga', toDecimalPoint(e.target.value).replace(/-/g, ''));
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === '-' || e.key === 'Minus') {
                        e.preventDefault();
                      }
                    }}
                    onBlur={(e) => {
                      if (!isFieldsLocked) {
                        const formatted = formatZapas(e.target.value);
                        updateYarus(yarus.id, 'zapassirga', formatted);
                      }
                    }}
                    readOnly={isFieldsLocked}
                    className={`form-control coordinate-field ${!tiersOptional && (!validatePositiveZapas(yarus.zapassirga)) ? 'required-field' : ''} ${isFieldsLocked ? 'locked-field' : ''}`}
                    style={isFieldsLocked ? { background: '#f8f9fa', cursor: 'not-allowed' } : {}}
                    placeholder="0.00"
                  />
                </td>

                {/* Запас сырораст., кбм на выдел */}
                <td className="coordinate-cell" style={{ minWidth: '150px', width: '150px' }}>
                  <DecimalInput
                    value={calculateZapasSyroVydel(yarus)}
                    readOnly={true}
                    className="form-control coordinate-field"
                    style={{ 
                      background: '#f8f9fa', 
                      cursor: 'not-allowed',
                      color: '#6c757d'
                    }}
                    placeholder="0.00"
                  />
                </td>

                {/* Запас сухостоя, кбм на выдел */}
                <td className="coordinate-cell" style={{ minWidth: '150px', width: '150px' }}>
                  <DecimalInput
                    value={yarus.zapassuh}
                    onChange={(e) => {
                      if (!isFieldsLocked) {
                        updateYarus(yarus.id, 'zapassuh', toDecimalPoint(e.target.value));
                      }
                    }}
                    onBlur={(e) => {
                      if (!isFieldsLocked) {
                        const formatted = formatZapas(e.target.value);
                        updateYarus(yarus.id, 'zapassuh', formatted);
                      }
                    }}
                    readOnly={isFieldsLocked}
                    className={`form-control coordinate-field ${!tiersOptional && (!yarus.zapassuh || !validateZapas(yarus.zapassuh)) ? 'required-field' : ''} ${isFieldsLocked ? 'locked-field' : ''}`}
                    style={isFieldsLocked ? { background: '#f8f9fa', cursor: 'not-allowed' } : {}}
                    placeholder="0.00"
                  />
                </td>

                {/* Запас редин, кбм на выдел */}
                <td className="coordinate-cell" style={{ minWidth: '150px', width: '150px' }}>
                  <DecimalInput
                    value={yarus.zapasred}
                    onChange={(e) => {
                      if (!isFieldsLocked) {
                        updateYarus(yarus.id, 'zapasred', toDecimalPoint(e.target.value));
                      }
                    }}
                    onBlur={(e) => {
                      if (!isFieldsLocked) {
                        const formatted = formatZapas(e.target.value);
                        updateYarus(yarus.id, 'zapasred', formatted);
                      }
                    }}
                    readOnly={isFieldsLocked}
                    className={`form-control coordinate-field ${!tiersOptional && (!yarus.zapasred || !validateZapas(yarus.zapasred)) ? 'required-field' : ''} ${isFieldsLocked ? 'locked-field' : ''}`}
                    style={isFieldsLocked ? { background: '#f8f9fa', cursor: 'not-allowed' } : {}}
                    placeholder="0.00"
                  />
                </td>

                {/* Запас един. дер., кбм на выдел */}
                <td className="coordinate-cell" style={{ minWidth: '150px', width: '150px' }}>
                  <DecimalInput
                    value={yarus.zapased}
                    onChange={(e) => {
                      if (!isFieldsLocked) {
                        updateYarus(yarus.id, 'zapased', toDecimalPoint(e.target.value));
                      }
                    }}
                    onBlur={(e) => {
                      if (!isFieldsLocked) {
                        const formatted = formatZapas(e.target.value);
                        updateYarus(yarus.id, 'zapased', formatted);
                      }
                    }}
                    readOnly={isFieldsLocked}
                    className={`form-control coordinate-field ${!tiersOptional && (!yarus.zapased || !validateZapas(yarus.zapased)) ? 'required-field' : ''} ${isFieldsLocked ? 'locked-field' : ''}`}
                    style={isFieldsLocked ? { background: '#f8f9fa', cursor: 'not-allowed' } : {}}
                    placeholder="0.00"
                  />
                </td>

                {/* Запас захл. общ., кбм на выдел */}
                <td className="coordinate-cell" style={{ minWidth: '150px', width: '150px' }}>
                  <DecimalInput
                    value={yarus.zapaszahl}
                    onChange={(e) => {
                      if (!isFieldsLocked) {
                        updateYarus(yarus.id, 'zapaszahl', toDecimalPoint(e.target.value));
                      }
                    }}
                    onBlur={(e) => {
                      if (!isFieldsLocked) {
                        const formatted = formatZapas(e.target.value);
                        updateYarus(yarus.id, 'zapaszahl', formatted);
                      }
                    }}
                    readOnly={isFieldsLocked}
                    className={`form-control coordinate-field ${!tiersOptional && (!yarus.zapaszahl || !validateZapas(yarus.zapaszahl)) ? 'required-field' : ''} ${isFieldsLocked ? 'locked-field' : ''}`}
                    style={isFieldsLocked ? { background: '#f8f9fa', cursor: 'not-allowed' } : {}}
                    placeholder="0.00"
                  />
                </td>

                {/* Запас захл. ликвид., кбм на выдел */}
                <td className="coordinate-cell" style={{ minWidth: '150px', width: '150px' }}>
                  <DecimalInput
                    value={yarus.zapaszahllik}
                    onChange={(e) => {
                      if (!isFieldsLocked) {
                        updateYarus(yarus.id, 'zapaszahllik', toDecimalPoint(e.target.value));
                      }
                    }}
                    onBlur={(e) => {
                      if (!isFieldsLocked) {
                        const formatted = formatZapas(e.target.value);
                        updateYarus(yarus.id, 'zapaszahllik', formatted);
                      }
                    }}
                    readOnly={isFieldsLocked}
                    className={`form-control coordinate-field ${!tiersOptional && (!yarus.zapaszahllik || !validateZapas(yarus.zapaszahllik)) ? 'required-field' : ''} ${isFieldsLocked ? 'locked-field' : ''}`}
                    style={isFieldsLocked ? { background: '#f8f9fa', cursor: 'not-allowed' } : {}}
                    placeholder="0.00"
                  />
                </td>

                {/* Действия */}
                <td className="coordinate-cell" style={{ 
                  minWidth: '100px', 
                  width: '100px',
                  textAlign: 'center',
                  verticalAlign: 'middle'
                }}>
                  {!isFieldsLocked && (
                    <button
                      type="button"
                      onClick={() => setYarusPendingDelete(yarus.id)}
                      style={{
                        background: '#6c757d',
                        color: 'white',
                        border: 'none',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        display: 'inline-block'
                      }}
                    >
                      Удалить
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {/* Слайдер для прокрутки таблицы */}
      <div style={{ 
        marginTop: '10px',
        padding: '10px',
        backgroundColor: '#f8f9fa',
        border: '1px solid #e9ecef',
        borderRadius: '6px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }}>
        <span style={{ 
          fontSize: '12px', 
          color: '#6c757d',
          minWidth: '60px'
        }}>
          Прокрутка:
        </span>
        <input
          type="range"
          min="0"
          max="100"
          value={tableScrollPosition}
          onChange={handleSliderChange}
          className="table-scroll-slider"
          style={{
            flex: 1
          }}
        />
        <span style={{
          fontSize: '12px',
          color: '#6c757d',
          minWidth: '30px',
          textAlign: 'right'
        }}>
          {Math.round(tableScrollPosition)}%
        </span>
      </div>

      {/* Подтверждение удаления яруса */}
      {yarusPendingDelete !== null && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div className="modal-content" style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '20px',
            maxWidth: '500px',
            width: '90%',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
          }}>
            <h3 style={{ margin: '0 0 15px 0', color: '#6c757d', fontSize: '16px', fontWeight: '600' }}>
              Удаление яруса
            </h3>
            <p style={{ margin: '0 0 20px 0', color: '#6c757d', lineHeight: '1.5', fontSize: '14px' }}>
              Точно ли хотите удалить все данные по ярусу? Это действие нельзя отменить.
            </p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button
                type="button"
                onClick={() => setYarusPendingDelete(null)}
                style={{
                  padding: '10px 20px',
                  border: '1px solid #6c757d',
                  backgroundColor: '#f8f9fa',
                  color: '#6c757d',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#e9ecef';
                  e.target.style.color = '#495057';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#f8f9fa';
                  e.target.style.color = '#6c757d';
                }}
              >
                Отмена
              </button>
              <button
                type="button"
                onClick={confirmDeleteYarus}
                style={{
                  padding: '10px 20px',
                  border: '1px solid #495058',
                  backgroundColor: '#495058',
                  color: 'white',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#3a4045';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#495058';
                }}
              >
                Удалить
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default YarusySection;

